<template>
  <v-container
    ref="container"
    v-resize="resize"
    class="widgetText--text widget pa-0"
    style="position: relative; height: 100%; overflow: hidden">
    <BaseWidgetHeader ref="widgetHeader" :label="labels.zone" @close-parent-widget="close" />
    <v-row class="pt-4 px-5">
      <v-col cols="7" align-self="center" class="pt-0 pb-4">
        <BaseTextField
          v-model="meters" :value="meters" :label="labels.pp"
          clearable />
      </v-col>
      <v-col cols="2">
        <BaseTooltip bottom>
          <template #activator="{on, attrs}">
            <v-btn
              v-bind="attrs"
              height="34" width="34"
              :color="circleTool.id === value ? $vuetify.theme.themes.dark.elements : defaultColor"
              :disabled="value === 'drawTool' || externalJsResult?.length > 0"
              :style="{
                color:
                  (circleTool.id === value)
                    ? $vuetify.theme.themes.dark.elementsText
                    : 'black'
              }"
              x-small elevation="0"
              v-on="on"
              @click="drawCircle">
              <v-icon> {{ circleTool.icon }}</v-icon>
            </v-btn>
          </template>
          {{ circleTool.title }}
        </BaseTooltip>
      </v-col>
      <v-col cols="2">
        <BaseTooltip bottom>
          <template #activator="{on, attrs}">
            <v-btn
              v-bind="attrs"
              height="34" width="34"
              :color="drawTool.id === value ? $vuetify.theme.themes.dark.elements : defaultColor"
              :disabled="value === 'drawCircle' || externalJsResult?.length > 0"
              :style="{
                color:
                  (drawTool.id === value)
                    ? $vuetify.theme.themes.dark.elementsText
                    : 'black'
              }"
              x-small elevation="0"
              v-on="on"
              @click="drawPolygone
              ">
              <v-icon> {{ drawTool.icon }}</v-icon>
            </v-btn>
          </template>
          {{ drawTool.title }}
        </BaseTooltip>
      </v-col>
      <v-col cols="12" align-self="center" class="pt-0 pb-4">
        <BaseTextField
          v-model="opis" :value="opis" :label="labels.opis"
          clearable />
      </v-col>
      <v-col cols="12" align-self="center" class="pt-0 pb-4">
        <BaseTextField
          v-model="komentar" :value="komentar" :label="labels.komentar"
          clearable />
      </v-col>
      <v-col v-if="externalJsResult.length > 0" cols="12">
        <span>{{ labels.rezultati }}</span>
        <BaseTooltip bottom>
          <template #activator="{on, attrs}">
            <v-icon
              v-bind="attrs" style="float:right" v-on="on"
              @click="removeFromExternal">
              mdi-cancel
            </v-icon>
          </template>
          Poništi rezultate iz tabele
        </BaseTooltip>
      </v-col>
    </v-row>
    <div
      id="footerDiv"
      ref="footerDiv"
      style="position: absolute; bottom: 0px; overflow: hidden; width: 100%"
      class="pt-4 pb-2">
      <v-row>
        <v-col cols="12" class="pb-2">
          <v-divider />
        </v-col>
      </v-row>
      <v-row
        align="center" align-content="center" justify="center"
        class="px-5">
        <v-col class="py-1 px-1" align-self="center" cols="12">
          <BasePrimaryBtn
            v-if="featureForEdit"
            class="px-0" :loading="loading"
            :title="labels.editZone"
            :disabled="disabledButton && !featureForEdit"
            :parent-widget="$options.name"
            @click="addZone" />
          <BasePrimaryBtn
            v-else
            class="px-0" :loading="loading"
            :title="labels.addZone"
            :disabled="disabledButton"
            :parent-widget="$options.name"
            @click="addZone" />
        </v-col>
        <v-col class="py-1 px-1" align-self="center" cols="12">
          <BasePrimaryBtn
            class="px-0" :loading="loading"
            :title="labels.geojson"
            :disabled="disabledButton && !featureForEdit"
            :parent-widget="$options.name"
            @click="downloadGeoJSON" />
        </v-col>

        <v-col class="py-1 px-1" align-self="center" cols="12">
          <BasePrimaryBtn
            class="px-0" :loading="loading"
            :title="labels.jpg"
            :disabled="disabledButton && !featureForEdit"
            :parent-widget="$options.name"
            @click="downloadJpg" />
        </v-col>

        <v-col class="py-1 px-1" align-self="center" cols="12">
          <BasePrimaryBtn
            class="px-0" :loading="loading"
            :title="labels.url"
            :disabled="disabledButton || !featureForEdit"
            :parent-widget="$options.name"
            @click="copyUrl" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import BaseTextField from '../components/UIElements/BaseTextField.vue'
import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel'
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer'
import graphicCreator from '../mixin/AG/graphicCreator'
import graphicsController from '../mixin/AG/graphicsController.js'
import { spEsri } from '../globals.js'
import Circle from '@arcgis/core/geometry/Circle'
import Graphic from '@arcgis/core/Graphic'
import featureLayerMixin from '@/mixin/AG/featureLayer.js'
import JSZip from 'jszip'
import * as queryTask from '@arcgis/core/rest/query'
import Query from '@arcgis/core/rest/support/Query'
import * as geometryEngineAsync from '@arcgis/core/geometry/geometryEngineAsync'
import * as XLSX from 'xlsx'

import * as projection from '@arcgis/core/geometry/projection.js'
import SpatialReference from '@arcgis/core/geometry/SpatialReference'
export default {
  name: 'Uzbuna',
  components: { BaseTextField },
  mixins: [featureLayerMixin, graphicCreator, graphicsController],
  defaultHighlightColor: { r: 51, g: 51, b: 204 },
  selectionGraphicsLayer: null,
  sketch: null,
  savedGeometryForQuerying: null,
  clickListener: null,
  data () {
    return {
      headerHeight: '0px',
      loading: false,
      meters: 5,
      defaultColor: '#bfc8cf',
      activeDrawing: false,
      opis: '',
      komentar: '',
      intersectUrlPutevi: 'https://192.168.1.3:6443/arcgis/rest/services/JKC/MapServer/5',
      intersectUrlEmiteri: 'https://pristupinternetu.mit.gov.rs/server/rest/services/JKC/MapServer/1',
      // addUrl: 'https://192.168.1.3:6443/arcgis/rest/services/JKC/FeatureServer/0',
      addUrl: 'https://pristupinternetu.mit.gov.rs/server/rest/services/JKC/FeatureServer/0',
      graphicCreated: false,
      addedFeature: null,
      value: null,
      featureFromQuery: null,
      urlQuery: null,
    }
  },
  computed: {
    activeTool () {
      return this.$store.getters.getActiveTool
    },
    externalJsResult () {
      return this.$store.getters.getExternalJs?.opstine ? this.$store.getters.getExternalJs?.opstine : []
    },
    featureForEdit () {
      if (this.addedFeature) {
        return this.addedFeature
      }
      return this.featureFromQuery
    },

    disabledButton () {
      return this.externalJsResult?.length === 0 && !this.graphicCreated
    },
    circleTool () { return { id: 'drawCircle', title: this.labels.krug, icon: 'mdi-circle-expand' } },
    drawTool () { return { id: 'drawTool', title: this.labels.poligon, icon: 'mdi-vector-polygon' } },

    allLabels () {
      return {
        en: {
          zone: 'Alert zones',
          pp: 'Radius in kilometers',
          krug: 'Draw a circle with the given radius',
          poligon: 'Draw a polygon',
          addZone: 'Add an alert zone',
          rezultati: ' Results from table',
          editZone: 'Izmeni zonu',
          emiteri: 'csv emiteri',
          putevi: 'csv putevi',
          opis: 'Opis',
          komentar: 'Komentar',
          geojson: 'geojson',
          url: 'url',
          jpg: 'jpg',
        },
        sr: {
          zone: 'Zone uzbunjivanja',
          pp: 'Poluprecnik u kilometrima',
          krug: 'Nacrtaj krug zadatog poluprecnika',
          poligon: 'Nacrtaj poligon',
          addZone: 'Dodaj zonu uzbune',
          rezultati: ' Rezultati iz tabele',
          editZone: 'Izmeni zonu',
          emiteri: 'csv emiteri',
          putevi: 'csv putevi',
          opis: 'Opis',
          komentar: 'Komentar',
          geojson: 'geojson',
          url: 'url',
          jpg: 'jpg',
        },
        cir: {
          zone: 'Зоне узбуњивања',
          pp: 'Полупречник у километрима',
          krug: 'Нацртај круг задатог полупречника',
          poligon: 'Нацртај полигон',
          addZone: 'Додај зону узбуне',
          rezultati: ' Резултати из табеле',
          editZone: 'Измени зону',
          emiteri: 'csv емитери',
          putevi: 'csv путеви',
          opis: 'Опис',
          komentar: 'Коментар',
          geojson: 'геојсон',
          url: 'урл',
          jpg: 'јпг',
        },
      }
    },
    labels () {
      return this.allLabels[this.$store.getters.getLanguage]
    },
  },
  watch: {

    activeTool (newValue) {
      if (newValue === 'Uzbuna') {
        this.resize()
      } else {
        this.value = null
        if (this.$options.selectionGraphicsLayer) {
          this.$options.selectionGraphicsLayer.removeAll()
          this.graphicCreated = false
        }
        if (this.$options.clickListener) {
          this.$options.clickListener.remove()
        }
      }
    },
    externalJsResult (newVal) {
      if (newVal) {
        if (this.$options.selectionGraphicsLayer) {
          this.$options.selectionGraphicsLayer.removeAll()
          this.graphicCreated = false
        }
      }
    },
  },
  created () {
    this.getFeatureFromQuery(this.$store.getters.getQuery)
  },
  methods: {
    arcgisFeatureToGeoJSON (arcgisFeature) {
      const ogcType = {
        point: 'Point',
        polyline: 'LineString',
        polygon: 'Polygon',
      }

      const geojson = {
        type: 'Feature',
        id: arcgisFeature.attributes ? arcgisFeature.attributes.objectid : null,
        properties: arcgisFeature.attributes || {},
        geometry: {
          type: ogcType[arcgisFeature.geometry.type],
          coordinates: [],
        },
      }

      switch (geojson.geometry.type) {
        case 'Point':
          geojson.geometry.coordinates = [arcgisFeature.geometry.x, arcgisFeature.geometry.y]
          break
        case 'LineString':
          geojson.geometry.coordinates = arcgisFeature.geometry.paths[0]
          break
        case 'Polygon':
          geojson.geometry.coordinates = arcgisFeature.geometry.rings
          break
        default:
          throw new Error('Unsupported geometry type')
      }

      return geojson
    },

    async downloadGeoJSON () {
      const layerName = 'zona_uzbune'
      let result = null
      const targetSpatialReference = new SpatialReference({ wkid: 4326 })

      if (this.featureFromQuery) {
        const projectedGeometry = projection.project(this.featureFromQuery.geometry, targetSpatialReference)
        const shpGraphic = new Graphic({
          geometry: projectedGeometry,
          symbol: {
            type: 'simple-fill',
            color: [51, 51, 204, 0.5],
            outline: {
              color: [51, 51, 204, 1],
              width: 2,
            },
          },
        })
        result = [shpGraphic]
      }

      if (this.externalJsResult.length > 0) {
        const geometries = []
        for (const item of this.externalJsResult) {
          geometries.push(item.geometry)
        }
        const union = await geometryEngineAsync.union(geometries)
        const projectedGeometry = projection.project(union, targetSpatialReference)
        const shpGraphic = new Graphic({
          geometry: projectedGeometry,
          symbol: {
            type: 'simple-fill',
            color: [51, 51, 204, 0.5],
            outline: {
              color: [51, 51, 204, 1],
              width: 2,
            },
          },
        })
        result = [shpGraphic]
      } else if (this.$options.selectionGraphicsLayer?.graphics.items) {
        result = this.$options.selectionGraphicsLayer.graphics.items.map(graphic => {
          const projectedGeometry = projection.project(graphic.geometry, targetSpatialReference)
          return new Graphic({
            geometry: projectedGeometry,
            symbol: graphic.symbol,
            attributes: graphic.attributes,
          })
        })
      }

      const geoJSONFileContents = []
      for (const feature of result) {
        if (this.featureForEdit) {
          this.featureForEdit.attributes.datum = new Date(this.featureForEdit.attributes.datum).toLocaleString('sr-RS', {
            timeZone: 'UTC',
          }
          )
          feature.attributes = this.featureForEdit.attributes
        }
        geoJSONFileContents.push(this.arcgisFeatureToGeoJSON(feature))
      }

      const geoJSON = {
        type: 'FeatureCollection',
        features: geoJSONFileContents,
        crs: {
          type: 'name',
          properties: {
            name: 'EPSG:4326',
          },
        },
      }

      const geoJSONFileContentsString = JSON.stringify(geoJSON, null, 2)
      const blob = new Blob([geoJSONFileContentsString], { type: 'application/json' })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const timestamp = this.getFormattedTimestamp()
      link.download = `${layerName}_${timestamp}.geojson`
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    getFormattedTimestamp  () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`
    },
    async getFeatureFromQuery (queryurl) {
      if (queryurl?.where) {
        const idPom = queryurl.where.split('=')
        const id = idPom[1].split(')')
        const query = new Query({
          outFields: ['*'],
          returnGeometry: true,
          where: 'objectId =' + id[0],
        })
        const result = await queryTask.executeQueryJSON(this.addUrl, query)
        if (result?.features && result.features.length > 0) {
          this.featureFromQuery = result.features[0]
          this.opis = result.features[0].attributes.opis
          this.komentar = result.features[0].attributes.komentar
        }
      }
    },
    async generateCsv (vrsta) {
      let geometryForIntersect = null
      if (this.featureFromQuery) {
        geometryForIntersect = this.featureFromQuery.geometry
      }
      if (this.externalJsResult.length > 0) {
        const geometries = []
        for (const item of this.externalJsResult) {
          geometries.push(item.geometry)
        }
        geometryForIntersect = await geometryEngineAsync.union(geometries)
      } else if (this.$options.savedGeometryForQuerying) {
        geometryForIntersect = this.$options.savedGeometryForQuerying
      }
      const query = new Query({
        outFields: ['*'],
        returnGeometry: false,
        geometry: geometryForIntersect,
        spatialRelationship: 'intersects',
      })
      let queryUrl = this.intersectUrlPutevi
      if (vrsta === 'emiteri') {
        queryUrl = this.intersectUrlEmiteri
      }
      const results = await queryTask.executeQueryJSON(queryUrl, query)
      for (const feat of results.features) {
        feat.attributes.mit_datum = new Date(feat.attributes.mit_datum).toLocaleDateString('de-DE')
      }
      let { fields, features } = results
      const filteredFields = fields.filter(field => field.name !== 'st_area(shape)' && field.name !== 'st_length(shape)')
      features = features.map(feature => {
        const attributes = feature?.attributes
        for (const key in attributes) {
          attributes[key] = attributes[key]?.toString().replace(/,/g, '').replace(/\r\n/g, ' ')
        }
        return feature
      })

      // Create the header row
      let csvContent = filteredFields.map(field => field.alias).join(',') + '\n'

      // Add the data rows
      features.forEach(feature => {
        const rowData = filteredFields.map(field => feature.attributes[field.name])
        csvContent += rowData.join(',') + '\n'
      })

      const csv = '\uFEFF' + csvContent
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'zone_uzbune.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    copyUrl () {
      // const url = 'http://localhost:8081/?queryConfig=serviceKey=8dd0f180-eabc-4455-b791-a770072c0c8f;layerId=0;where=(objectId =' + this.featureForEdit.attributes.objectid + ')#/jkcPortal/home'

      const url = 'https://pristupinternetu.mit.gov.rs/smartViewer/?queryConfig=serviceKey=8dd0f180-eabc-4455-b791-a770072c0c8f;layerId=0;where=(objectId =' + this.featureForEdit.attributes.objectid + ')#/jkcPortal/home'
      navigator.clipboard.writeText(url)
      this.$store.dispatch('showSnackbar', { color: 'success', code: 'queryUrlCopied' })
    },
    removeFromExternal () {
      const externalJs = { ...this.$store.getters.getExternalJs }
      externalJs.opstine = null
      this.$store.dispatch('storeExternalJs', externalJs)
    },

    drawPolygone () {
      this.activeDrawing = !this.activeDrawing

      this.value = 'drawTool'

      if (!this.initSketch) {
        this.initSelectionGraphicLayer()
        this.initSketch = true
      }
      if (!this.activeDrawing) {
        this.value = null
        this.$options.sketch.destroy()
        this.$options.sketch = null
        if (this.$options.clickListener) {
          this.$options.clickListener.remove()
        }
        this.$store.dispatch('unsetCurrentWidgetFromMapInteraction', this.$options.name)
        return
      }
      this.$store.dispatch('setActiveMapInteractionWidget', this.$options.name)
      this.$options.sketch = new SketchViewModel({
        view: spEsri.activeView,
        layer: this.$options.selectionGraphicsLayer,
        updateOnGraphicClick: false,
      })
      this.$options.sketch.create('polygon', { mode: 'click' })
      this.$options.sketch.on('create', (event) => {
        if (event.state === 'complete') {
          this.clearPrevGraphicsAndQueryUsingNewGeom(event.graphic.geometry, 'polygon')
          this.$options.sketch.create('polygon', { mode: 'click' })
        }
      })
    },
    async  downloadJpg () {
      this.loading = true
      const screenshot = await spEsri.activeView.takeScreenshot({
        format: 'jpg',
        width: 800,
        height: 800,
      })
      this.loading = false

      const downloadElement = document.createElement('a')

      const documentTitle =
         'screenshot_' + new Date().toLocaleTimeString()
      downloadElement.href = screenshot.dataUrl

      downloadElement.target = '_blank'
      downloadElement.download = documentTitle
      downloadElement.style.display = 'none'
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
    },
    async downloadShp () {
      const zip = new JSZip()
      const layerName = 'zona_uzbune'
      let result = null
      let coordSystem = "GEOGCS['GCS_WGS_1984',DATUM['D_WGS_1984',SPHEROID['WGS_1984',6378137.0,298.257223563]],PRIMEM['Greenwich',0.0],UNIT['Degree',0.0174532925199433]]"
      if (spEsri.activeView.spatialReference.isWebMercator) {
        coordSystem = 'PROJCS["WGS_1984_Web_Mercator_Auxiliary_Sphere",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Mercator_1SP"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",0.0],PARAMETER["Standard_Parallel_1",0.0],PARAMETER["Auxiliary_Sphere_Type",0.0],UNIT["Meter",1.0]]'
      }
      if (this.featureFromQuery) {
        const targetSpatialReference = new SpatialReference({ wkid: 102100 })

        // Project the geometry to the target spatial reference
        const projectedGeometry = projection.project(this.featureFromQuery.geometry, targetSpatialReference)
        const shpGraphic = new Graphic({
          geometry: projectedGeometry,
          symbol: {
            type: 'simple-fill',
            color: [51, 51, 204, 0.5],
            outline: {
              color: [51, 51, 204, 1],
              width: 2,
            },
          },
        })
        result = [shpGraphic]
      }

      if (this.externalJsResult.length > 0) {
        // result = this.externalJsResult
        const geometries = []
        for (const item of this.externalJsResult) {
          geometries.push(item.geometry)
        }
        const union = await geometryEngineAsync.union(geometries)
        const shpGraphic = new Graphic({
          geometry: union,
          symbol: {
            type: 'simple-fill',
            color: [51, 51, 204, 0.5],
            outline: {
              color: [51, 51, 204, 1],
              width: 2,
            },
          },
        })
        result = [shpGraphic]
      } else if (this.$options.selectionGraphicsLayer?.graphics.items) {
        result = this.$options.selectionGraphicsLayer.graphics.items
      }
      const fields = []

      const outputObject = window.JS2Shapefile.createShapeFiles(result, 'UTF8', coordSystem, layerName, fields)
      for (const createdFile in outputObject) {
        if (outputObject[createdFile].successful) {
          for (const fileInShape in outputObject[createdFile].shapefile) {
            zip.file(outputObject[createdFile].shapefile[fileInShape].name, outputObject[createdFile].shapefile[fileInShape].blob)
          }
        }
      }
      const vm = this
      zip.generateAsync({
        type: 'arraybuffer',
      }).then(function (arraybuffer) {
        vm.downloadFile(arraybuffer, 'application/zip', layerName + '.zip', true)
      })
    },
    downloadFile (content, mimeType, fileName, useBlob, dataUri) {
      mimeType = mimeType || 'application/octet-stream'
      const dataURI = dataUri || 'data:' + mimeType + ',' + content
      const link = document.createElement('a')
      const blob = new Blob([content], {
        type: mimeType,
      })

      if (typeof (link.download) !== 'undefined') {
        const url = useBlob ? window.URL.createObjectURL(blob) : dataURI

        link.setAttribute('href', url)
        link.setAttribute('download', fileName)
        link.style = 'visibility:hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return null
      } else if (navigator.msSaveOrOpenBlob) {
        return navigator.msSaveOrOpenBlob(blob, fileName)
      }

      window.open(dataURI)
      window.focus()
      return null
    },
    drawCircle () {
      this.activeDrawing = !this.activeDrawing

      this.value = 'drawCircle'

      if (!this.initSketch) {
        this.initSelectionGraphicLayer()
        this.initSketch = true
      }

      if (!this.activeDrawing) {
        this.value = null
        if (this.$options.sketch) {
          this.$options.sketch.destroy()
          this.$options.sketch = null
        }
        if (this.$options.clickListener) {
          this.$options.clickListener.remove()
        }
        this.$store.dispatch('unsetCurrentWidgetFromMapInteraction', this.$options.name)
        return
      }

      this.$store.dispatch('setActiveMapInteractionWidget', this.$options.name)

      this.$options.sketch = new SketchViewModel({
        view: spEsri.activeView,
        layer: this.$options.selectionGraphicsLayer,
        updateOnGraphicClick: false,
      })

      this.$options.clickListener = spEsri.activeView.on('click', (clickEvent) => {
        this.$options.selectionGraphicsLayer.removeAll()
        const center = {
          type: 'point',
          x: clickEvent.mapPoint.x,
          y: clickEvent.mapPoint.y,
          spatialReference: spEsri.activeView.spatialReference,
        }

        const circleGeometry = new Circle({
          center: center,
          radius: this.meters * 1000,
          radiusUnit: 'meters',
        })

        const circleGraphic = new Graphic({
          geometry: circleGeometry,
          symbol: {
            type: 'simple-fill',
            color: [51, 51, 204, 0.5],
            outline: {
              color: [51, 51, 204, 1],
              width: 2,
            },
          },
        })
        this.$options.savedGeometryForQuerying = circleGeometry
        this.$options.selectionGraphicsLayer.add(circleGraphic)
        this.graphicCreated = true
      })
    },

    initSelectionGraphicLayer () {
      this.$options.selectionGraphicsLayer = new GraphicsLayer({ mode: 'on-the-ground' })
      spEsri.map.add(this.$options.selectionGraphicsLayer)
    },
    clearPrevGraphicsAndQueryUsingNewGeom (geometry, graphicType) {
      this.$options.selectionGraphicsLayer.removeAll()
      this.$options.savedGeometryForQuerying = geometry
      this.createSelectionGraphic(geometry, graphicType)
    },
    async createSelectionGraphic (geometry, graphicType) {
      this.graphicCreated = true
      this.$options.selectionGraphicsLayer.add(this.createGraphic({ geometry: geometry, ...this.$options.defaultHighlightColor, graphicType: graphicType }))
    },
    async downloadXls () {
      let geometryForIntersect = null
      if (this.featureFromQuery) {
        geometryForIntersect = this.featureFromQuery.geometry
      }
      if (this.externalJsResult.length > 0) {
        const geometries = []
        for (const item of this.externalJsResult) {
          geometries.push(item.geometry)
        }
        geometryForIntersect = await geometryEngineAsync.union(geometries)
      } else if (this.$options.savedGeometryForQuerying) {
        geometryForIntersect = this.$options.savedGeometryForQuerying
      }
      const query = new Query({
        outFields: ['*'],
        returnGeometry: false,
        geometry: geometryForIntersect,
        spatialRelationship: 'intersects',
      })
      const results = await queryTask.executeQueryJSON(this.intersectUrl, query)

      for (const feat of results.features) {
        feat.attributes.mit_datum = new Date(feat.attributes.mit_datum).toLocaleDateString('de-DE')
      }
      const { fields, features } = results
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet([], { header: fields.map(field => field.alias) })

      // Append rows with feature data
      features.forEach(feature => {
        const rowData = fields.map(field => feature.attributes[field.name])
        XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: -1 })
      })

      // Create a new workbook and add the worksheet
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')

      // Convert the workbook to a binary string
      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })

      // Create a Blob from the binary string
      const blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' })

      // Create a link element and trigger the download
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'zone_uzbune.xlsx'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    s2ab (s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF
      }
      return buf
    },
    async downloadXlm () {
      let geometryForIntersect = null
      if (this.featureFromQuery) {
        geometryForIntersect = this.featureFromQuery.geometry
      }
      if (this.externalJsResult.length > 0) {
        const geometries = []
        for (const item of this.externalJsResult) {
          geometries.push(item.geometry)
        }
        geometryForIntersect = await geometryEngineAsync.union(geometries)
      } else if (this.$options.savedGeometryForQuerying) {
        geometryForIntersect = this.$options.savedGeometryForQuerying
      }
      const query = new Query({
        outFields: ['*'],
        returnGeometry: false,
        geometry: geometryForIntersect,
        spatialRelationship: 'intersects',
      })
      const results = await queryTask.executeQueryJSON(this.intersectUrl, query)
      const xmlData = this.jsonToXml(results)
      const blob = new Blob([xmlData], { type: 'application/xml' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'zone_uzbune.xml'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    jsonToXml (jsonData) {
      let xml = '<?xml version="1.0" encoding="UTF-8"?>\n'
      xml += '<root>\n'
      xml += `  <displayFieldName>${jsonData.displayFieldName}</displayFieldName>\n`
      xml += '  <fields>\n'

      jsonData.fields.forEach(field => {
        if (field.name !== 'st_area(shape)' && field.name !== 'st_length(shape)') {
          xml += '    <field>\n'
          xml += `      <alias>${field.alias}</alias>\n`
          xml += `      <name>${field.name}</name>\n`
          xml += `      <type>${field.type}</type>\n`
          xml += '    </field>\n'
        }
      })

      xml += '  </fields>\n'
      xml += '  <features>\n'

      jsonData.features.forEach(feature => {
        xml += '    <feature>\n'
        xml += '      <attributes>\n'

        for (const [key, value] of Object.entries(feature.attributes)) {
          if (key !== 'st_area(shape)' && key !== 'st_length(shape)') {
            xml += `        <${key}>${value}</${key}>\n`
          }
        }

        xml += '      </attributes>\n'
        xml += '    </feature>\n'
      })

      xml += '  </features>\n'
      xml += '</root>'

      return xml
    },
    getCurrentFormattedDateTime () {
      const date = new Date()
      const month = String(date.getMonth() + 1)
      const day = String(date.getDate())
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`
    },
    async addZone () {
      const fl = await this.getFeatureLayer(this.addUrl)
      let feature = null
      if (this.featureFromQuery) {
        feature = this.featureFromQuery
      }
      if (this.externalJsResult.length > 0) {
        const geometries = []
        for (const item of this.externalJsResult) {
          geometries.push(item.geometry)
        }

        const geometryForEdit = await geometryEngineAsync.union(geometries)
        const editGraphic = new Graphic({
          geometry: geometryForEdit,
          symbol: {
            type: 'simple-fill',
            color: [51, 51, 204, 0.5],
            outline: {
              color: [51, 51, 204, 1],
              width: 2,
            },
          },
        })
        feature = editGraphic
      } else if (this.$options.selectionGraphicsLayer?.graphics.items[0]) {
        feature = this.$options.selectionGraphicsLayer.graphics.items[0]
      }

      try {
        if (this.featureForEdit) {
          await fl.applyEdits({ deleteFeatures: [this.featureForEdit] })
        }
        feature.attributes = {}
        feature.attributes.opis = this.opis
        feature.attributes.komentar = this.komentar
        feature.attributes.datum = this.getCurrentFormattedDateTime()

        const response = await fl.applyEdits({ addFeatures: [feature] })

        if (response.addFeatureResults[0]) {
          const query = new Query({
            outFields: ['*'],
            returnGeometry: false,
            where: 'objectId =' + response.addFeatureResults[0].objectId,
          })

          const result = await queryTask.executeQueryJSON(this.addUrl, query)
          for (const mil in spEsri.mapImageLayers) {
            const zone = spEsri.mapImageLayers[mil].sublayers.items.find(e => e.id === 0)
            zone.definitionExpression = 'objectId= ' + response.addFeatureResults[0].objectId
          }
          this.addedFeature = result.features[0]
        } else {
          this.$store.dispatch('showSnackbar', { color: 'error', code: 'addFailure' })
        }

        for (const mil in spEsri.mapImageLayers) {
          spEsri.mapImageLayers[mil].refresh()
        }
        this.$store.dispatch('showSnackbar', { color: 'success', code: 'addSuccess' })
      } catch {
        this.$store.dispatch('showSnackbar', { color: 'error', code: 'addFailure' })
      }
    },
    close () {
      this.$options.selectionGraphicsLayer?.removeAll()
      this.graphicCreated = false
      this.$options.savedGeometryForQuerying = null
      this.$store.dispatch('unsetCurrentWidgetFromMapInteraction', this.$options.name)
      this.$store.dispatch('unSetActiveTool')
    },
    resize () {
      if (this.activeTool === 'Uzbuna') {
        const containerH = this.$refs.container.clientHeight
        const titleH = this.$refs.widgetHeader.$refs.title.clientHeight
        const dividerH = this.$refs.widgetHeader.$refs.divider.clientHeight
        const tabsH = 30
        const layersH = this.layers ? this.$refs.layers.clientHeight : 0
        const footerH = this.$refs.footerDiv?.clientHeight ? this.$refs.footerDiv?.clientHeight : 0
        this.footerHeight = footerH + 'px'
        const h = containerH - titleH - dividerH - layersH - footerH - tabsH
        this.computedHeight = h + 'px'
      }
    },

  },
}
</script>

<style scoped>
.absolutePosition {
    position: absolute;
    display: block;
    z-index: 100;
}
.column-name {
  font-weight: 500;
  font-size: 14px;
}
</style>
